import styles from "./Navigation.module.css";
const Navigation = (props) => {
  const { menus } = props;
  //? getting all the category from the dataset
  let category = menus.map((menu) => {
    return menu.category;
  });
  category = new Set(category);
  category = ["all", ...category];
  
  const clickCategoryHandler = (category) => {
    props.onChange(category);
  };
  return (
    <nav className={styles["navigation"]}>
      <ul>
        {category.map((category) => {
          return (
            <li
              key={Math.random()}
              onClick={() =>
                clickCategoryHandler(category)
              }
            >
              {category}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Navigation;
